import React from "react";
import { Field } from "react-final-form";

export const Spot = ( { when, children } ) => {
    return <Field name={ when } subscription={ { value: true } }>
        { ( { input: { value } } ) => ((value === undefined || value === null || value.length < 1) ? null : children) }
    </Field>
}